import { render, staticRenderFns } from "./PurchaseApply.vue?vue&type=template&id=6252a3bc&scoped=true&"
import script from "./PurchaseApply.vue?vue&type=script&lang=js&"
export * from "./PurchaseApply.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseApply.vue?vue&type=style&index=0&id=6252a3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252a3bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VForm,VTextField})
